
(() => {
  "use strict";

  const site =
    document.querySelector(
      "[data-frushi-site]"
    );

  if (!site) {
    return;
  }

  const hero =
    site.querySelector(
      ".frushi-hero"
    );

  const reduceMotion =
    window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;


  if (
    hero
    && !reduceMotion
  ) {

    hero.addEventListener(
      "pointermove",
      (event) => {

        const rect =
          hero.getBoundingClientRect();

        const x =
          (
            (event.clientX - rect.left)
            / rect.width
          ) - 0.5;

        const y =
          (
            (event.clientY - rect.top)
            / rect.height
          ) - 0.5;

        hero.style.setProperty(
          "--frushi-mouse-x",
          x.toFixed(3)
        );

        hero.style.setProperty(
          "--frushi-mouse-y",
          y.toFixed(3)
        );

      }
    );

    hero.addEventListener(
      "pointerleave",
      () => {

        hero.style.setProperty(
          "--frushi-mouse-x",
          "0"
        );

        hero.style.setProperty(
          "--frushi-mouse-y",
          "0"
        );

      }
    );

  }


  const revealItems =
    site.querySelectorAll(
      "[data-frushi-reveal]"
    );


  if (
    reduceMotion
    || !("IntersectionObserver" in window)
  ) {

    revealItems.forEach(
      (item) => {

        item.classList.add(
          "frushi-visible"
        );

      }
    );

    return;
  }


  const observer =
    new IntersectionObserver(
      (entries, instance) => {

        entries.forEach(
          (entry) => {

            if (!entry.isIntersecting) {
              return;
            }

            entry.target.classList.add(
              "frushi-visible"
            );

            instance.unobserve(
              entry.target
            );

          }
        );

      },
      {
        threshold: 0.12,
        rootMargin:
          "0px 0px -40px 0px"
      }
    );


  revealItems.forEach(
    (item) => {

      observer.observe(
        item
      );

    }
  );

})();

/* FRUSHI ACCESSIBILITY + POLISH V1 START */

(function () {
  "use strict";

  function ready(callback) {
    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        callback,
        { once: true }
      );
    } else {
      callback();
    }
  }


  ready(function () {

    /* =====================================================
       MARQUEE PAUSE / PLAY
    ====================================================== */

    var reducedMotion =
      window.matchMedia &&
      window.matchMedia(
        "(prefers-reduced-motion: reduce)"
      ).matches;


    var marquees =
      document.querySelectorAll(
        ".frushi-marquee"
      );


    marquees.forEach(function (marquee, index) {

      if (
        marquee.querySelector(
          ".frushi-motion-toggle"
        )
      ) {
        return;
      }


      var button =
        document.createElement(
          "button"
        );


      button.type =
        "button";

      button.className =
        "frushi-motion-toggle";

      button.setAttribute(
        "aria-controls",
        "frushi-marquee-" + index
      );


      if (!marquee.id) {
        marquee.id =
          "frushi-marquee-" + index;
      }


      function setPaused(paused) {

        marquee.classList.toggle(
          "is-paused",
          paused
        );

        button.setAttribute(
          "aria-pressed",
          paused ? "true" : "false"
        );

        button.setAttribute(
          "aria-label",
          paused
            ? "Play scrolling text"
            : "Pause scrolling text"
        );

        button.innerHTML =
          paused
            ? '<span aria-hidden="true">▶</span>'
            : '<span aria-hidden="true">Ⅱ</span>';

      }


      setPaused(
        reducedMotion
      );


      if (reducedMotion) {
        marquee.classList.add(
          "is-reduced-motion"
        );
      }


      button.addEventListener(
        "click",
        function () {

          var isPaused =
            marquee.classList.contains(
              "is-paused"
            );

          marquee.classList.remove(
            "is-reduced-motion"
          );

          setPaused(
            !isPaused
          );

        }
      );


      marquee.appendChild(
        button
      );

    });


    /* =====================================================
       BACK TO TOP BUTTON
    ====================================================== */

    if (
      !document.querySelector(
        ".frushi-back-to-top"
      )
    ) {

      var topButton =
        document.createElement(
          "button"
        );


      topButton.type =
        "button";

      topButton.className =
        "frushi-back-to-top";

      topButton.setAttribute(
        "aria-label",
        "Back to top"
      );

      topButton.innerHTML =
        '<span aria-hidden="true">↑</span>';


      document.body.appendChild(
        topButton
      );


      var ticking =
        false;


      function updateTopButton() {

        var shouldShow =
          window.scrollY > 650;


        topButton.classList.toggle(
          "is-visible",
          shouldShow
        );


        ticking =
          false;

      }


      window.addEventListener(
        "scroll",
        function () {

          if (!ticking) {

            window.requestAnimationFrame(
              updateTopButton
            );

            ticking =
              true;

          }

        },
        { passive: true }
      );


      updateTopButton();


      topButton.addEventListener(
        "click",
        function () {

          var useReducedMotion =
            window.matchMedia &&
            window.matchMedia(
              "(prefers-reduced-motion: reduce)"
            ).matches;


          window.scrollTo({
            top: 0,
            behavior:
              useReducedMotion
                ? "auto"
                : "smooth"
          });

        }
      );

    }

  });

})();

/* FRUSHI ACCESSIBILITY + POLISH V1 END */
